import { StateCreator } from 'zustand';
import { getFormFieldsModel } from './error.service.ts';
import { IErrorModalProps, IErrorSlice } from '@Types/index.ts';
import { Icons } from '@Components/icon/Icon.tsx';
export const createErrorSlice: StateCreator<IErrorSlice> = (set, get) => ({
  errorSlice: {
    errorModal: {
      error: '',
      modalProps: {
        title: '',
        content: '',
        icon: Icons.Oops,
        buttonText: '',
        type: undefined,
        onSubmit: () => {},
      },
    },
    setErrorModal: (data: { error: string; modalProps?: IErrorModalProps }) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          errorModal: data,
        },
      }),
    formFieldErrors: getFormFieldsModel(),
    setFormFieldError: (field, error) =>
      set({
        errorSlice: {
          ...get().errorSlice,
          formFieldErrors: {
            ...get().errorSlice.formFieldErrors,
            [field]: error,
          },
        },
      }),
    resetFormFieldErrors: () =>
      set({
        errorSlice: {
          ...get().errorSlice,
          formFieldErrors: getFormFieldsModel(),
        },
      }),
  },
});
